import React from "react";
import PropTypes from "prop-types";
import md5 from "md5";

export default class Comment extends React.Component{
    render(){
        const gravatar = `https://www.gravatar.com/avatar/${md5(this.props.email)}?s=200&d=mm`;

        return(
            <div className="card w-100 post-comment">
                <div className="card-body">
                    <div className="row">
                        <div className="col-1">
                            <img src={gravatar} />
                        </div>
                        <div className="col-11">
                            <strong>{this.props.user}</strong>
                            <p><small>{this.props.date}</small></p>
                            <p>{this.props.content}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Comment.propTypes = {
    email: PropTypes.string.isRequired,
    user: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired
};
